export default __webpack_public_path__ + "static/media/tapeOne.080d7b57.svg";